import { Box, Image, Link, Slide } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { dispatchAudioAnalytics } from '../../Analytics';
import backgroundAudio from '../../assets/audios/common.mp3';
// import CreatedByEmperia from '../../assets/images/created_by_emperia.png';
import InfoImg from '../../assets/images/info.svg';
import InfoImgHover from '../../assets/images/info_hover.svg';
import MapImg from '../../assets/images/map.svg';
import MapImgHover from '../../assets/images/map_hover.svg';
import PassportImg from '../../assets/images/passport.svg';
import PassportImgHover from '../../assets/images/passport_hover.svg';
import AudioOff from '../../assets/images/sound_off.svg';
import AudioOffHover from '../../assets/images/sound_off_hover.svg';
import AudioOn from '../../assets/images/sound_on.svg';
import AudioOnHover from '../../assets/images/sound_on_hover.svg';
import { OverlayProps } from '../../interfaces/components';
import AudioToggleModal from '../../pages/AudioToggleModal';
import HoverImage from '../common/HoverImage';
import LanguageSwitcher from '../common/LanguageSwitcher';
import Minimap from './Minimap';
import StampCollected from '../common/StampCollected';
import TBCCreatedByEmperia from '../../assets/images/tbc_created_by_emperia.png';
import { disptchCTAClickObject, dispatchCollectItemAnalytics } from '../../Analytics';

const key = 'LaRocaStamps';

const Overlay = ({ activeScene, toggleInstructions, openFirstModal, togglePassport }: OverlayProps) => {
  const [collectedStampsIds, setCollectedStampsIds] = useState<string[]>([]);
  const [showCollectedModal, setShowCollectedModal] = useState(false);
  // const [prevActiveScene, setPrevActiveScene] = useState<string>('');
  const [audioModal, setAudioModal] = useState(true);
  const [audioActive, setAudioActive] = useState(false);
  const myRef = useRef<HTMLAudioElement>(null);
  const [tabVisible, setTabVisible] = useState<boolean>(true);

  // EventListeners
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') setTabVisible(true);
    else setTabVisible(false);
  });

  useEffect(() => {
    if (audioActive && !tabVisible) {
      if (myRef.current) {
        dispatchAudioAnalytics(false, 'laroca');
        myRef.current.pause();
        setAudioActive(false);
      }
    }
  }, [tabVisible]);

  const toggleAudio = () => {
    if (!audioActive) {
      if (myRef.current) {
        dispatchAudioAnalytics(true, 'laroca');
        myRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (myRef.current) {
        dispatchAudioAnalytics(false, 'laroca');
        myRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  const toggleMap = () => {
    window.toggleMap('laroca');
  };

  const playInitialAudio = (state: boolean) => {
    if (state) {
      if (myRef.current) {
        myRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (myRef.current) {
        myRef.current.pause();
        setAudioActive(false);
      }
    }
    openFirstModal();
  };

  // useEffect(() => {
  //   //Changing Music for apartment.
  //   //Audio need to pause and play, no other way to change src in runtime
  //   if (activeScene && audioActive) {
  //     if (prevActiveScene && prevActiveScene !== '') {
  //       const prevName = prevActiveScene.toLowerCase().split('_');
  //       const activeName = activeScene.toLowerCase().split('_');
  //       // console.log('Difference', audioActive, prevName[0], activeName[0]);
  //       if (prevName[1] !== activeName[1]) {
  //         myRef.current?.pause();
  //         myRef.current?.play();
  //       }
  //     }

  //     setPrevActiveScene(activeScene);
  //   }
  // }, [activeScene, audioActive]);

  useEffect(() => {
    if (showCollectedModal) {
      setTimeout(() => {
        setShowCollectedModal(false);
      }, 2500);
    }
  }, [showCollectedModal]);

  const onStampClick = (id: string) => {
    // console.log('Id', id, collectedStampsIds, typeof id, typeof collectedStampsIds);
    let mastervalue = [];
    const value = localStorage.getItem(key);
    // console.log('Local value', value);

    if (value && value !== null) {
      mastervalue = JSON.parse(value);
    }
    if (mastervalue.findIndex((stampId: string) => stampId === id) === -1) {
      // setCollectedStamps((value) => ++value);
      // const newIds = collectedStampsIds;
      // newIds.push(id);
      const newIds = [...mastervalue, id];
      // console.log('New Ids', newIds);
      setCollectedStampsIds(newIds);
      localStorage.setItem(key, JSON.stringify(newIds));
      setShowCollectedModal(true);

      dispatchCollectItemAnalytics('passportStamp', newIds.length.toString(), 'laroca');
      if (newIds.length >= 3) {
        togglePassport();
      }
    }
  };

  useEffect(() => {
    const value = localStorage.getItem(key);
    // console.log('Local value', value);

    if (value && value !== null) {
      const parsedValue = JSON.parse(value);
      const newValue = parsedValue;

      // Reset Collected Tokens on new Visit
      // if (parsedValue.length >= 3) {
      //   localStorage.setItem(key, JSON.stringify([]));
      //   newValue = [];
      // }

      setCollectedStampsIds(newValue);
    }

    window.onStampClick = onStampClick;
  }, []);

  return (
    <Box className="layout">
      {/* Audio Layer */}
      {/* <audio ref={myRef} src={activeScene.includes('apartment') ? apartmentAudio : backgroundAudio} /> */}
      <audio ref={myRef} src={backgroundAudio} />

      {/* Audio Popup */}
      <AudioToggleModal
        proceedAudio={(state: boolean) => {
          playInitialAudio(state);
          setAudioModal(false);
          dispatchAudioAnalytics(state, 'laroca');
        }}
        active={audioModal}
      />

      {/* Right Floating Buttons */}
      <Box
        position="fixed"
        top={['15px', '20px', '25px']}
        right={['15px', '20px', '25px']}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
      >
        <HoverImage
          w={['40px', '40px', '50px']}
          h={['40px', '40px', '50px']}
          src={MapImg}
          hover={MapImgHover}
          onClick={toggleMap}
        />
        {audioActive ? (
          <HoverImage
            w={['40px', '40px', '50px']}
            h={['40px', '40px', '50px']}
            src={AudioOn}
            hover={AudioOnHover}
            onClick={toggleAudio}
          />
        ) : (
          <HoverImage
            w={['40px', '40px', '50px']}
            h={['40px', '40px', '50px']}
            src={AudioOff}
            hover={AudioOffHover}
            onClick={toggleAudio}
          />
        )}
        <HoverImage
          w={['40px', '40px', '50px']}
          h={['40px', '40px', '50px']}
          src={InfoImg}
          hover={InfoImgHover}
          onClick={toggleInstructions}
        />
        <HoverImage
          w={['40px', '40px', '50px']}
          h={['40px', '40px', '50px']}
          src={PassportImg}
          hover={PassportImgHover}
          onClick={togglePassport}
        />
      </Box>

      <Slide direction="right" in={showCollectedModal} style={{ zIndex: 10 }}>
        <Box
          position="fixed"
          top={['130px', '130px', '170px']}
          right={['65px', '70px', '90px']}
          userSelect="none"
          pointerEvents="none"
        >
          <StampCollected collected={collectedStampsIds.length} fill="#FFD41F" stroke="#FFD93B" />
        </Box>
      </Slide>

      <Box
        position="fixed"
        bottom={['15px', '20px', '25px']}
        left={['10px', '15px', '25px']}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
        userSelect="none"
        pointerEvents="none"
      >
        <Minimap activeScene={activeScene} />
      </Box>

      <Box
        position="fixed"
        bottom={['70px', '70px', '25px']}
        right={['15px', '15px', '250px']}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
      >
        <LanguageSwitcher
          onLanguageSelect={(name: string) => {
            disptchCTAClickObject('laroca', 'Button', 'LanguageSelect', name, '');
          }}
        />
      </Box>

      {/* Created By Emperia Link */}
      <Link href="https://emperiavr.com/" target="_blank" tabIndex={-1} userSelect="none">
        <Box
          position="fixed"
          bottom={['15px', '15px', '25px']}
          right={['15px', '15px', '25px']}
          cursor="pointer"
          zIndex={3}
        >
          <Image
            src={TBCCreatedByEmperia}
            width={['190px', '190px', '200px', '200px', '200px', '200px']}
            loading="lazy"
          />
        </Box>
      </Link>
    </Box>
  );
};

export default Overlay;
